import React from "react";
import styled from "styled-components";
import { fonts } from "theme/fonts";

export const Countdown = ({ label, days, hours, minutes, seconds }) => {
  return (
    <CountdownContainer xCenter>
      <CountdownTitle>{label}</CountdownTitle>
      <GridRow>
        {days >= 1 && (
          <Outline xCenter>
            <Increment>{days}</Increment>
            <Label>Día{days !== 1 ? "s" : ""}</Label>
          </Outline>
        )}
        <Outline xCenter>
          <Increment>{hours}</Increment>
          <Label>Hora{hours !== 1 ? "s" : ""}</Label>
        </Outline>
        <Outline xCenter>
          <Increment>{minutes}</Increment>
          <Label>Minuto{minutes !== 1 ? "s" : ""}</Label>
        </Outline>
        {days < 1 && (
          <Outline xCenter>
            <Increment>{seconds}</Increment>
            <Label>Segundo{seconds !== 1 ? "s" : ""}</Label>
          </Outline>
        )}
      </GridRow>
    </CountdownContainer>
  );
};

const CountdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 15px;
  width: 100%;
`;

const CountdownTitle = styled.h3`
  color: #ffffff;
  font-family: ${fonts.brandBold};
  font-size: 32px;
  margin-bottom: 10px;
  text-transform: uppercase;
  text-align: center;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 75px;
    margin-bottom: 30px;
  }
`;

const GridRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
  max-width: 600px;
`;

const Increment = styled.div`
  color: #ffffff;
  font-family: ${fonts.brandBold};
  font-size: 50px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 125px;
  }
`;

const Label = styled.div`
  color: #ffffff;
  font-family: ${fonts.brandRegular};
  font-size: 16px;
  text-transform: uppercase;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 30px;
  }
`;

const Outline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  & + & {
    margin-left: 9px;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    & + & {
      margin-left: 24px;
    }
  }
`;
